import { render, staticRenderFns } from "./schoolArea.vue?vue&type=template&id=807a07e8&scoped=true&"
import script from "./schoolArea.vue?vue&type=script&lang=js&"
export * from "./schoolArea.vue?vue&type=script&lang=js&"
import style0 from "./schoolArea.vue?vue&type=style&index=0&id=807a07e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "807a07e8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
